import { appendGOATandCountryCodeToTitle, getText } from 'shared/utils/pageMetadataUtils';

import { IProductTemplate } from 'shared/types/ProductTemplate';
import { t } from 'localization/utils/t';

const TP = 'shared.utils.getPdpMetadata';

export const getPdpMetadata = ({ pageTitle, pageDescription, locale, productTemplate, query }) => {
  const {
    name: ptName = '',
    sku = '',
    color = '',
    details: colorDetails = '',
    silhouette = '',
    brandName = '',
  }: IProductTemplate = productTemplate;

  let title = '';
  let description = '';
  const dashSku = getText('-', sku);
  const dashColor = getText('-', color);
  const colorDescription = (colorDetails || color).toLocaleLowerCase();

  if (query?.pageSlug === 'sneakers') {
    title = t(`${TP}.sneakersTitle`, 'Buy {ptName} {dashSku} {dashColor}', {
      ptName,
      dashSku,
      dashColor,
    });
    description = t(
      `${TP}.sneakersDescription`,
      'Shop the {ptName} and other sneaker drops on GOAT. The {silhouette} comes in {colorDescription}. Buyer protection guaranteed on all purchases.',
      {
        ptName,
        silhouette,
        colorDescription,
      },
    );
  } else {
    title = t(`${TP}.defaultTitle`, 'Buy {ptName} {dashSku}', {
      ptName,
      dashSku,
    });
    description = t(
      `${TP}.defaultDescription`,
      'Shop the {ptName} and other curated styles from {brandName} on GOAT. Buyer protection guaranteed on all purchases.',
      {
        ptName,
        brandName,
      },
    );
  }

  return {
    pageTitle: pageTitle || appendGOATandCountryCodeToTitle(title, locale),
    pageDescription: pageDescription || description,
  };
};
